import { useState, useRef } from "react";
import SignatureCanvas from "react-signature-canvas";
import { FiCheck } from "react-icons/fi";
import DropZoneSignature from "../dropZoneSignature";
import SignatureImage from '../../../assets/images/signature.svg'
import Info from '../../../assets/icons/info.svg'
import html2canvas from 'html2canvas';
import axios from "axios";

const SignatureModal = ({ setIsToggledModal, setFinalFile }) => {
    const [activeTab, setActiveTab] = useState("draw");
    const [errorMessage, setErrorMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [font, setFont] = useState('Arial, sans-serif');
    const [selectedColor, setSelectedColor] = useState("#20232D");
    const [file, setFile] = useState([]);
    const [upload, setUpload] = useState([]);
    const [signatureImg, setSignatureImg] = useState();


    const [signatureText, setSignatureText] = useState("");

    const handleTextChange = (e) => {
        if(errorMessage){
            setErrorMessage("");
        }
        setSignatureText(e.target.value);
        console.log("Signature Text:", e.target.value);
    };

    const sigCanvas = useRef(null);

    const colors = [
        { color: "#20232D", value: "black" },
        { color: "#375DFB", value: "blue" },
        { color: "#DF1C41", value: "red" },
    ];


    const uploadFiles = async (formData2) => {
        const response = await axios.post(
            "https://micro-helper.ascend.com.sa/minio/uploads",
            formData2,
            {
                headers: {

                    Accept: "*/*",
                },
            }
        );
        return response;
    };

    const captureRef = useRef(null);

    const base64ToFile = async (base64Data, filename) => {
        // Remove the base64 prefix (data:image/png;base64,)
        const base64String = base64Data.split(',')[1];

        // Decode the base64 string into bytes
        const byteCharacters = atob(base64String);

        // Create an array to hold the byte data
        const byteArrays = [];

        // Convert the byte characters into an array of bytes
        for (let offset = 0; offset < byteCharacters.length; offset++) {
            byteArrays.push(byteCharacters.charCodeAt(offset));
        }

        // Create a Blob from the byte array
        const byteArray = new Uint8Array(byteArrays);
        const blob = new Blob([byteArray], { type: 'image/png' });

        // Create a File from the Blob
        const file = new File([blob], filename, { type: 'image/png' });

        return file;
    };


    const handleCapture = async () => {
        if(activeTab === "type" && !signatureText){
            setErrorMessage("Please type your signature.");
            return;
        }

        if (captureRef.current) {
            try {
            
            setIsLoading(true);
            // Wrap the textarea inside a div container
            const wrapper = document.createElement('div');
            wrapper.style.position = 'absolute';
            wrapper.style.left = '-9999px';  // Move off-screen
            wrapper.style.whiteSpace = 'pre-wrap';  // Preserve text formatting
            wrapper.style.padding = window.getComputedStyle(captureRef.current).padding;
            wrapper.style.fontFamily = window.getComputedStyle(captureRef.current).fontFamily;
            wrapper.style.fontSize = window.getComputedStyle(captureRef.current).fontSize;
            wrapper.style.color = window.getComputedStyle(captureRef.current).color;
            wrapper.style.backgroundColor = window.getComputedStyle(captureRef.current).backgroundColor;
            wrapper.style.width = `${"600"}px`;  // Full width
            wrapper.style.height = `${"300"}px`; // Full height

            // Clone the textarea content and append it to the wrapper
            wrapper.textContent = captureRef.current.value;
            document.body.appendChild(wrapper);

            // Capture the wrapper using html2canvas
            const canvas = await html2canvas(wrapper, {
                scale: 4, // Higher scale for better quality
                useCORS: true,
                backgroundColor: null, // Transparent background
            });

            document.body.removeChild(wrapper);  // Clean up the DOM



            // Convert canvas to image and download
            const imageURL = canvas.toDataURL('image/png');
            const file = await base64ToFile(imageURL, 'image.png');

            const formDataFile = new FormData();
            formDataFile.append("project", "visitingdoctor");
            formDataFile.append("files", file);
            // file.forEach((file) => {
            //     if (typeof file === "string") {

            //     } else {
            //       // Append each file to formData

            //     }
            // });
            const response = await uploadFiles(formDataFile);
            setFile(response?.data?.paths[0])
            const downloadLink = document.createElement('a');
            downloadLink.href = imageURL;
            handleUpload();
        } catch (error) {
            setIsLoading(false);
        }
            // downloadLink.download = 'Signature.png';
            // downloadLink.click();
        }
    };

    const handleUpload = async (file) => {
        if(activeTab === "upload" && upload.length === 0){
            setErrorMessage("Please upload your signature.");
            return;
        }
        let requestData;
        setIsLoading(true);
        if (activeTab === "draw") {
            requestData = { action: "draw", data: "drawData" };
            let response;
            const formDataFile = new FormData();
            formDataFile.append("project", "visitingdoctor");
            formDataFile.append("files", file);
            response = await uploadFiles(formDataFile);
            requestData = response?.
                data?.paths[0]
        } else if (activeTab === "type") {
            requestData = signatureText
        } else {
            let response;
            console.log({ upload })
            const formDataFile = new FormData();
            formDataFile.append("project", "visitingdoctor");


            upload.forEach((file) => {
                if (typeof file === "string") {

                } else {
                    formDataFile.append("files", file); // Append each file to formData

                }
            });
            response = await uploadFiles(formDataFile);
            requestData = response?.
                data?.paths[0] // Default case
        }
        setIsLoading(false);
        setFinalFile(requestData)
    }

    const handleFontChange = (e) => {
        setFont(e.target.value);
    };


    const clearSignature = () => {
        sigCanvas.current.clear();
    };

    const saveSignature = async () => {
        if(sigCanvas.current.isEmpty()){
            setErrorMessage("Please draw your signature.");
            return;
        }
        try {
            setIsLoading(true);
            const signatureImage = sigCanvas.current.toDataURL();
            const file = await base64ToFile(signatureImage, 'image.png');
            setSignatureImg(file);
            handleUpload(file);
        } catch (error) {
            setIsLoading(false);
        }

    };

    return (
        <div className="max-w-lg bg-white rounded-lg shadow-lg p-6 absolute z-10 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
            <div className="flex justify-start items-center mb-4 gap-3">
                <img src={SignatureImage} alt="logo" />
                <h2 className="text-xl font-semibold">Add Signature</h2>
            </div>

            {/* Tabs */}
            <div className="flex border-b mb-6">
                {["draw", "type", "upload"].map((tab) => (
                    <button
                        key={tab}
                        className={`flex-1 text-center py-2 ${activeTab === tab
                            ? "border-b-2 border-[#176448] text-[#176448]"
                            : "text-gray-500"
                            }`}
                        onClick={() => {
                            setActiveTab(tab);
                            setErrorMessage("");
                            setUpload([]);
                            setSignatureText("");
                            setSignatureImg();
                        }

                        }

                    >
                        {tab.charAt(0).toUpperCase() + tab.slice(1)}
                    </button>
                ))}
            </div>

            {/* Tab Content */}
            <div>
                {activeTab === "draw" && (
                    <div className="space-y-4">
                        <SignatureCanvas
                            ref={sigCanvas}
                            penColor="black"
                            canvasProps={{
                                className: "border border-gray-300 w-full h-48 rounded-lg bg-[#F6F8FA]",
                            }}
                            onBegin={()=>setErrorMessage("")}
                        />

                        <div className="mt-4 flex space-x-4">
                            {/* <button
                                onClick={saveSignature}
                                className="px-4 py-2 bg-blue-500 text-white rounded-lg"
                            >
                                Save Signature
                            </button> */}
                            <button
                                onClick={clearSignature}
                                className="px-4 py-2 bg-red-500 text-white rounded-lg"
                            >
                                Clear
                            </button>
                        </div>
                    </div>
                )}
                {activeTab === "type" && (

                    <div className="space-y-4">
                        <div className="relative">
                            <select className="p-2 mb-2 absolute z-0 bg-transparent border-0 w-2/5" onChange={handleFontChange}>
                                <option value="Arial, sans-serif">Arial</option>
                                <option value="'Times New Roman', Times, serif">Times New Roman</option>
                                <option value="'Great Vibes', cursive">Great Vibes</option>
                            </select>
                            <textarea
                                ref={captureRef}
                                className="z-10 w-full h-48 border-0 outline-none resize-none bg-[#F6F8FA] rounded-lg text-center text-xl leading-[3rem] pt-[5rem]"
                                placeholder="Type your signature here..."
                                style={{ fontFamily: font, fontSize: '2rem', color: selectedColor || "black", }}

                                onChange={handleTextChange}
                            />

                            {/* <button
                                onClick={handleCapture}
                                className="mt-4 px-4 py-2 bg-[#176448] text-white rounded"
                            >
                                Capture Screenshot
                            </button> */}
                            <div className="absolute top-2 right-2 flex space-x-2">
                                {colors.map((color, index) => {


                                    return (
                                        <button
                                            key={index}
                                            style={{ backgroundColor: color.value }}
                                            onClick={() => setSelectedColor(color.value)} // Set the selected color
                                            className={`flex items-center justify-center rounded-full  ${selectedColor === color.value ? "w-7 h-7" : "w-6 h-6"
                                                } bg-[${color.color}] relative transition-all duration-200`}
                                        >
                                            {selectedColor === color.value && (
                                                <FiCheck
                                                    className="absolute"
                                                    size={16} // Adjust size for the tick
                                                    color="white" // Ensures the tick is white
                                                />
                                            )}
                                        </button>
                                    )
                                }
                                )}
                            </div>
                        </div>
                    </div>
                )}
                {activeTab === "upload" && (
                    <DropZoneSignature

                        onChange={(acceptedFiles) => {
                            if(errorMessage){
                                setErrorMessage("");
                            }
                            // Update Formik state with accepted files
                            setUpload(acceptedFiles)
                        }}
                        value={upload}

                    />
                )}
                {errorMessage !== "" &&<div className="text-red-500 text-sm mt-1">{errorMessage}</div>}
                <div className="flex items-start gap-2 mt-3">
                    <img src={Info} />
                    <p className="text-sm text-gray-500">
                        By signing this document with an electronic signature, I agree
                        that such signature will be as valid as handwritten signatures to
                        the extent allowed by local law.
                    </p>
                </div>
            </div>

            {/* Footer */}
            <div className="flex justify-end space-x-4 mt-6">
                <button
                    disabled={isLoading}
                    onClick={() => {

                        setIsToggledModal(false)
                    }}

                    className="px-4 py-2 border rounded-md text-gray-500">
                    Dismiss
                </button>
                <button onClick={() => {
                    activeTab === "draw" ? saveSignature() : activeTab === "type" ? handleCapture() :
                        handleUpload(signatureImg)
                }}
                    disabled={isLoading}

                    className="px-4 py-2 bg-[#176448] text-white rounded-md">
                    {isLoading ? (
                        <div className="loader border-t-2 border-white w-5 h-5 rounded-full animate-spin"></div>
                    ) : (
                        "Accept & Sign"
                    )}
                </button>
            </div>
        </div >
    );
};

export default SignatureModal;
